import axios from "axios";
import { config } from "../config";


const getStack360Token = () => {
  const token = localStorage.getItem("_stack360_token");
  return token;
}

const instance =  axios.create({
  baseURL: config.API_URL,
  headers: {
    "Content-type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Credentials": true,
  },
});


// Request Interceptor
instance.interceptors.request.use(
  (axiosConfig)=>{
    const token = getStack360Token();
    if (token) {
      axiosConfig.headers["x-auth-token"] = token;
    }

    if(!axiosConfig.headers["Accept"]){
      axiosConfig.headers["Accept"] = "application/json";
    }
    return axiosConfig;
  }
);



export default instance;




